<template>
  <div class="restaurant-wrapper">
    <loading :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="fullPage"
      :height="height"
      :width="width"
      :color="color"
      :loader="loader">
    </loading>
    <h3 class="page-header">Restaurants</h3>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="header">
            <slot name="header">
              <h4 class="title">Participating Restaurants</h4>
            </slot>
          </div>
          <div class="full_width">
            <div class="col-md-3 error_height">
              <div class="form-group">
                <label style="color: #000;">Filter:</label>
                <input type="text" v-model="searchText" class="form-control border-input" placeholder="Start Typing"/>
              </div>
            </div>
          </div>
          <div class="content table-responsive table-full-width">
            <table class="table table-hover restaurant-table">
              <thead>
                <th v-for="column in table.columns">
                  <a href="#" @click="sortBy(column)" :class="{ active: sortKey == column }">
                    {{column}}
                  </a>
                </th>
              </thead>
              <tbody>
                <tr v-for="(item, key, index) in restaurantsSearch">
                  <td>{{item.entityStoreNumber}}</td>
                  <td>{{item.entityName}}</td>
                  <td>{{item.entityAddress.address}}</td>
                  <td>{{item.entityAddress.city}}</td>
                  <td>{{item.entityAddress.state}}</td>
                  <td>{{item.entityAddress.zip}}</td>
                  <td>{{item.isOpen}}</td>
                  <td><a target="_blank" v-bind:href="item.DSP_URL">{{item.DSP_NAME}}</a></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {API} from 'src/api'
  import _ from 'lodash'
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';

  if(localStorage.userInfo) {
    var userInfo = JSON.parse(localStorage.userInfo)
  }
  export default {
    components: {
      Loading
    },
    data () {
      return {
        table: {
          columns: [],
          data: [],
          rids: []
        },
        searchText: '',
        restaurants: [],
        sortKey: ['Name'],
        sortOrder: ['asc'],
        // showModal: false,
        isModalVisible: false,
        isLoading: false,
        fullPage: true,
        height: 128,
        width: 128,
        color: '#0647A6',
        loader: 'bars'
      }
    },
    computed: {
      restaurantsSearch:function() {
      	 var self = this;
         if( this.searchText == ''){
           return this.restaurants;
         }

         return this.restaurants.filter(function(item){
           if(item.entityId.toLowerCase().indexOf(self.searchText.toLowerCase())>=0) {
             return item;
           }
           if(item.entityName.toLowerCase().indexOf(self.searchText.toLowerCase())>=0) {
             return item;
           }
           if(item.entityStoreNumber.toLowerCase().indexOf(self.searchText.toLowerCase())>=0) {
             return item;
           }
           if(item.address.toLowerCase().indexOf(self.searchText.toLowerCase())>=0) {
             return item;
           }
           if(item.entityAddress.city.toLowerCase().indexOf(self.searchText.toLowerCase())>=0) {
             return item;
           }
           if(item.entityAddress.state.toLowerCase().indexOf(self.searchText.toLowerCase())>=0) {
             return item;
           }
           if(item.entityAddress.zip.toLowerCase().indexOf(self.searchText.toLowerCase())>=0) {
             return item;
           }
           if(item.isOpen.toLowerCase().indexOf(self.searchText.toLowerCase())>=0) {
             return item;
           }
           if(item.DSP_NAME.toLowerCase().indexOf(self.searchText.toLowerCase())>=0) {
             return item;
           }
         });
      }
    },
    methods: {
      showModal () {
        this.isModalVisible = true
      },
      closeModal () {
        this.isModalVisible = false
      },
      getRestaurants (sortKey, sortOrder) {
        this.isLoading = true
        this.restaurants = []
        var self = this
        self.restaurants = []
        self.table.columns = ['Store Number', 'Name', 'Address', 'City', 'State', 'ZIP', 'Status', 'DSP']
        API.get('/restaurant/NP?np=' + userInfo.company + '&role=' + userInfo.role + '&sortkey=' + sortKey + '&sortorder=' + sortOrder + '&uid=' + userInfo.uid)
        .then(function (response) {
          console.log('getRestaurants', response)
          // eslint-disable-next-line
          if(response.data.entities) {
            for (let rest of Object.values(response.data.entities)) {
              self.restaurants.push(rest)
            }
          }
          self.isLoading = false
        })
        .catch(function (error) {
          console.log(error)
        })
      },
      sortBy (key) {
        if(key == 'Store Number') key = 'STORENUMBER'
        this.isLoading = true
        if (key == this.sortKey) {
            this.sortOrder = (this.sortOrder == 'asc') ? 'desc' : 'asc';
        } else {
            this.sortKey = key;
            this.sortOrder = 'asc';
        }
        this.getRestaurants(this.sortKey, this.sortOrder)
      }
    },
    mounted () {
      this.getRestaurants()
    }
  }
</script>
<style scoped>
th {
  padding-right: 0 !important;
  padding-bottom: 10px !important;
  padding-left: 5px !important;
}
.card .restaurant-table.table tbody td:first-child, .card .restaurant-table.table thead th:first-child {
  padding-left: 15px !important;
}
#btn {
  width: 100%;
}
/* .card .header {
  text-align: left !important;
} */
.full_width {
  width: 100%;
  float: left;
}
</style>



// WEBPACK FOOTER //
// Restaurants.vue?40692606